const locale = {
  appName: 'Kiness',
  tagline: 'Giữ gia đình luôn gắn kết',
  signIn: 'Đăng nhập',
  signUp: 'Đăng ký',
  signOut: 'Đăng xuất',
  email: 'Email',
  password: 'Mật khẩu',
  name: 'Họ và tên',
  facilityCode: 'Mã cơ sở',
  facilityCodeHint: 'Hãy hỏi cơ sở chăm sóc để lấy mã này',
  noAccount: 'Chưa có tài khoản?',
  haveAccount: 'Đã có tài khoản?',
  signingIn: 'Đang đăng nhập…',
  creatingAccount: 'Đang tạo tài khoản…',
  loginError: 'Không thể đăng nhập — kiểm tra email và mật khẩu',
  registerError: 'Không thể tạo tài khoản — vui lòng thử lại',
  welcomeBack: 'Chào mừng trở lại',
  welcomeNew: 'Tham gia cộng đồng chăm sóc của bạn',
  selectResident: 'Cập nhật này dành cho ai?',
  updatePlaceholder: 'Hôm nay {name} thế nào?',
  addPhoto: 'Thêm ảnh',
  postUpdate: 'Đăng cập nhật',
  posting: 'Đang đăng…',
  postSuccess: 'Đã đăng — gia đình sẽ được thông báo',
  postError: 'Không thể đăng — kiểm tra kết nối và thử lại',
  yourLovedOne: 'Người thân của bạn',
  familyFeed: 'Bảng tin gia đình',
  tabFeed: 'Bảng tin',
  tabRecord: 'Nhật ký',
  tabCalendar: 'Lịch',
  tabPhotos: 'Ảnh',
  noUpdates: 'Chưa có cập nhật — hãy quay lại sau',
  pullRefresh: 'Kéo xuống để làm mới',
  refreshing: 'Đang làm mới…',
  admin: 'Quản trị',
  dashboard: 'Bảng điều khiển',
  residents: 'Cư dân',
  familyLinks: 'Liên kết gia đình',
  staff: 'Nhân viên',
  facility: 'Cơ sở',
  residentsCount: 'Cư dân',
  familyLinked: 'Gia đình đã liên kết',
  updatesToday: 'Cập nhật hôm nay',
  addResident: 'Thêm cư dân',
  editResident: 'Chỉnh sửa',
  removeResident: 'Xóa',
  firstName: 'Tên',
  lastName: 'Họ',
  room: 'Phòng',
  save: 'Lưu',
  cancel: 'Hủy',
  addFamilyEmail: 'Thêm gia đình qua email',
  addStaffEmail: 'Thêm nhân viên qua email',
  staffAdd: 'Thêm',
  staffCount: '{count} nhân viên',
  relationship: 'Quan hệ',
  inviteSent: 'Lời mời đã sẵn sàng — họ có thể đăng ký bằng mã cơ sở',
  loading: 'Đang tải…',
  installTitle: 'Thêm Kiness vào màn hình chính',
  installBody: 'Truy cập nhanh các cập nhật về người thân của bạn',
  installButton: 'Thêm vào Màn hình chính',
  installDismiss: 'Để sau',
  language: 'Ngôn ngữ',
  chooseLanguage: 'Chọn ngôn ngữ của bạn',
  chooseLanguageSub: '选择您的语言',
  changeLanguageHint: 'Bạn có thể đổi bất cứ lúc nào qua biểu tượng quả địa cầu',
  english: 'English',
  chinese: '中文',
  newUpdate: 'Cập nhật mới',
  from: 'từ',
  roomLabel: 'Phòng',
  confirmRemove: 'Xóa cư dân này?',
  staffPostTitle: 'Đăng cập nhật',
  adminTitle: 'Bảng điều khiển cơ sở',
  linkedFamily: 'Gia đình đã liên kết',
  pendingInvite: 'Lời mời đang chờ',
  noResidents: 'Chưa có cư dân — hãy thêm người đầu tiên',
  noStaff: 'Chưa có nhân viên',
  photoOptional: 'Ảnh (tùy chọn)',
  dashboardSettingUp: 'Đang thiết lập bảng điều khiển…',
  dashboardEmptyHint: 'Thêm cư dân đầu tiên để bắt đầu',
};

export default locale;
